export default __webpack_public_path__ + "static/media/clicked-enabled.bad12502.svg";